import styled, {css} from "styled-components/macro";
import {device} from "../../styles";
import {IsDisabled, IsVisibleOnMobile} from "../../data";

export const Root = styled.div<IsVisibleOnMobile & IsDisabled>`
    align-items: flex-start;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
    gap: 15px 30px;

    ${device.less1180} {
        gap: 5px 30px;
    }

    ${device.less768} {
        width: 100%;
        flex-wrap: wrap;
        gap: 15px;
        display: none;

        ${(props) => props.$isVisibleOnMobile && css`
            display: flex;
        `}
    }

    ${(props) => props.$isDisabled && css`
        pointer-events: none;
    `}
`;

export const Item = styled.div`
    display: flex;
    align-items: center;
    
    ${device.less768} {
        flex: 1;
        min-width: 90px;
    }
`;
